import { render, staticRenderFns } from "./PicklHistory.vue?vue&type=template&id=380c11c2&scoped=true&"
import script from "./PicklHistory.vue?vue&type=script&lang=ts&"
export * from "./PicklHistory.vue?vue&type=script&lang=ts&"
import style0 from "./PicklHistory.vue?vue&type=style&index=0&id=380c11c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c11c2",
  null
  
)

export default component.exports